import { loadTwitterWidgetsSafe } from '@utils/loadTwitterWidget';
import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

class XEmbedBlot extends BlockEmbed {
  static create(value: any) {
    // 항상 노드를 반환 (null 금지)
    const node = super.create() as HTMLElement;

    // 값 정규화
    let raw = typeof value === 'string' ? value.trim() : '';
    if (
      !raw &&
      typeof value === 'object' &&
      value &&
      typeof (value as any).url === 'string'
    ) {
      raw = ((value as any).url || '').trim();
    }

    // 유효성 검사: 트위터/X 상태 URL만 허용
    const twitterUrlPattern =
      /^https:\/\/(x\.com|twitter\.com)\/\w+\/status\/\d+(\?.*)?$/;
    const isValidTwitterUrl = !!raw && twitterUrlPattern.test(raw);

    if (!isValidTwitterUrl) {
      // 유효하지 않을 경우: 숨김/앵커 대신 원문 텍스트를 그대로 출력
      try {
        node.removeAttribute('contenteditable');
        node.removeAttribute('data-url');
        node.classList.remove('x-embed');
        node.innerHTML = '';
        node.textContent = raw || '';
      } catch {
        // noop
      }
      return node;
    }

    // 정상 케이스: 위젯 블록 구성
    const normalizedUrl = raw.replace('https://x.com/', 'https://twitter.com/');
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('data-url', normalizedUrl);
    node.classList.add('x-embed');

    const blockquote = document.createElement('blockquote');
    blockquote.className = 'twitter-tweet';

    // 에디터 실제 폭 기준으로 트윗 렌더링 폭을 동적으로 지정해
    // iframe 높이 계산 불일치(하단 잘림)를 줄인다.
    const editorEl = document.querySelector('.ql-editor') as HTMLElement | null;
    const editorWidth = editorEl?.clientWidth || 0;
    const resolvedWidth =
      editorWidth > 0 ? Math.max(280, Math.min(editorWidth - 16, 550)) : 0;
    if (resolvedWidth > 0) {
      blockquote.setAttribute('data-width', String(Math.floor(resolvedWidth)));
    }

    const a = document.createElement('a');
    a.href = normalizedUrl;
    a.textContent = 'now loading...' + normalizedUrl;

    blockquote.appendChild(a);
    node.innerHTML = '';
    node.appendChild(blockquote);

    // 반응형 스타일 적용
    node.style.maxWidth = '100%';

    // 트위터 위젯 스크립트 적용
    loadTwitterWidgetsSafe();

    return node;
  }
  static value(node: HTMLElement) {
    // 텍스트 우선 -> data-url -> a[href] 순으로 반환
    const text = node.textContent?.trim();
    if (text) return text;
    const direct = node.getAttribute('data-url') || '';
    if (direct) return direct;
    const a = node.querySelector('a[href]') as HTMLAnchorElement | null;
    return a?.href || '';
  }
}

XEmbedBlot.blotName = 'x';
XEmbedBlot.tagName = 'div';
// div 전체를 가로채지 않도록 className으로만 매칭
(XEmbedBlot as any).className = 'x-embed';

export default XEmbedBlot;
